import type { SelectOption } from '@/components/ui/Select';

export const PLAN_TIER_OPTIONS: ReadonlyArray<SelectOption> = [
  { value: 'trial', label: 'Trial' },
  { value: 'starter', label: 'Starter' },
  { value: 'pro', label: 'Pro' },
  { value: 'enterprise', label: 'Enterprise' },
];

export const COUNTRY_OPTIONS: ReadonlyArray<SelectOption> = [
  { value: 'CO', label: 'Colombia' },
  { value: 'MX', label: 'México' },
  { value: 'PE', label: 'Perú' },
  { value: 'CL', label: 'Chile' },
];
